<div fxLayout="column">
    <div class="breadcrumb">
        <p>
        <a [routerLink]="'/dashboard'" class="breadcrumb-link">Home</a> /
        <span>OTA Job Details</span> 
        </p>
    </div>  
        <div class="container">
        <mat-card>
                <table class="table">
                        <tbody>
                        <tr *ngFor="let item of flattenedData | keyvalue">
                            <ng-container>
                            <td>{{ item.key | uppercase }}</td>
                            <td id="device-{{ item.key }}">{{ item.value }}</td>
                            </ng-container>
                        </tr>
                        </tbody>
                    </table>
        </mat-card>
        </div>
</div>



